<template>
  <!-- <transition name="fade"> -->
    <div class="design-list">
      <div class="list-container">
        <!-- <Icon type="md-close" @click="close" size="18" class="close-ico" /> -->
        <!-- <div class="main-title">已确认款式列表</div> -->
        <div class="container" ref="scrollContainer">
          <div class="status-list">
            <div class="search" style="right: 35px">
              <img
                src="@/assets/images/icon-search.png"
                alt=""
                class="icon-search"
              />
              <input
                type="text"
                placeholder="搜索方案名称"
                v-model="form_data.keyword"
                class="input"
                @keyup.enter="search"
              />
            </div>
          </div>
          <template v-if="design_list.length > 0">
            <div class="list">
              <div
                class="item"
                v-for="(v, k) in design_list"
                :key="`d` + k"
                @click="go(v)"
              >
                <div class="left">
                  <img :src="v.image | default_img" alt="" class="image" />
                </div>
                <div class="right">
                  <div class="right-box">
                    <div class="name-wrap">
                      <div class="name" :title="v.name">{{ v.name }}</div>
                      <div class="status" :class="oc(v)">
                        {{ v.status_name }}
                      </div>
                    </div>
                    <div class="style_no" :title="v.style_no">
                      <span>款号</span>：{{ v.style_no }}
                    </div>
                    <div class="category" :title="v.product_category_name">
                      <span>款式分类</span>：{{ v.product_category_name }}
                    </div>
                    <div class="step" v-if="v.status >= 3" :title="v.factory_price">
                      设计报价：{{ v.factory_price }}元
                    </div>
                    <div class="desc" :title="v.description">
                      <span>款式说明</span>：{{ v.description }}
                    </div>
                    <div class="time" :title="v.update_time">创建时间：{{ v.update_time }}</div>
                    <div class="btn-group">
                      <div
                        class="btn btn-del"
                        v-if="v.status === 4"
                        @click.stop="onsale(v)"
                      >
                        上架
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 底部加载状态提示 -->
            <div class="load-more-tip" v-if="!load_end">
              <span v-if="loading">加载中...</span>
            </div>
            <div class="load-more-tip" v-else>
              <span>没有更多数据了</span>
            </div>
          </template>
          <template v-else>
            <img
              src="@/assets/images/no-data.png"
              style="width: 300px; display: block; margin: 0 auto"
              alt=""
            />
          </template>
        </div>
      </div>
    </div>
  <!-- </transition> -->
</template>
<script>
import { DesignList } from "@/api/index";
export default {
  name: "DesignList",
  data() {
    return {
      design_list: [],
      form_data: {
        status: 4,
        page: 1,
        limit: 10,
      },
      load_end: false,
      loading:false
    };
  },
  mounted() {
    this.getDesignList();
    this.$nextTick(() => {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.addEventListener("scroll", this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听，防止内存泄漏
    const container = this.$refs.scrollContainer;
    if (container) {
      container.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    handleScroll(e) {
      const target = e.target;
      // 滚动条距离底部的距离 < 50px 时触发加载
      const isBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight < 50;

      if (isBottom && !this.loading && !this.load_end) {
        this.onLoadMore();
      }
    },
    close() {
      this.$emit("close");
    },
    oc(v) {
      return [v.status_text];
    },
    onLoadMore() {
      if (this.loading || this.load_end) return;
      this.form_data.page++;
      this.getDesignList(true); // 传入 true 表示是加载更多
    },
    onsale({ uuid, product }) {
        this.close();
      if (product) {
        //>已上架过商品的款式直接跳转编辑商品
        this.$router.push({
          name: "ProductEdit",
          query: { uuid: product.uuid },
        });
        return;
      }
      this.$router.push({ name: "ProductEdit", query: { design_uuid: uuid } });
    },
    search() {
      this.form_data.page = 1;
      this.load_end = false;
      this.design_list = []; // 清空旧数据
      this.getDesignList();
    },
    async getDesignList(isLoadMore = false) {
      if (this.loading) return;
      this.loading = true;
      try {
        const { code, msg, data } = await DesignList(this.form_data);
        if (code > 0) {
          this.$layer.msg(msg);
        }
        if (isLoadMore) {
          this.design_list = [...this.design_list, ...data];
        } else {
          this.design_list = data;
        }
        if (data.length < this.form_data.limit) {
          this.load_end = true;
        } else {
          this.load_end = false;
        }
      } catch (error) {
        console.error("获取设计列表失败", error);
        this.$layer.msg("加载失败，请重试");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.design-list {
  width: 100%;
  height: 100%;
  user-select: none;
  .list-container {
    // width: 1300px;
    // height: 600px;
    // max-height: 800px;
    // overflow-y: auto;
    // position: relative;
    background: #fff;
    border-radius: 10px;
    // .close-ico {
    //   position: absolute;
    //   top: 14px;
    //   right: 14px;
    //   cursor: pointer;
    // }
    // .main-title {
    //   width: 100%;
    //   text-align: center;
    //   margin-top: 18px;
    //   padding-bottom: 13px;
    //   font-size: 18px;
    //   font-weight: bold;
    //   color: #0f1115;
    //   border-bottom: 1px solid #e0e0e0;
    // }
    .container {
      padding: 0 70px 0 30px;
      background: white;
      // max-height: calc(600px - 80px);
      // overflow-y: auto;

      .load-more-tip {
        width: 100%;
        text-align: center;
        padding: 20px 0;
        color: #999;
        font-size: 14px;
      }
      .status-list {
        // position: relative;
        padding: 15px 0;
        display: flex;
        align-items: center;
        justify-content:flex-end;

        .search {
          display: flex;
          align-items: center;
          background: #f3f4f6;
          border-radius: 25px;
          padding: 0 20px;
          .icon-search {
            width: 20px;
            height: 20px;
          }
          .input {
            width: 260px;
            height: 50px;
            line-height: 50px;
            padding-left: 10px;
            font-size: 14px;
            outline: none;
            border: none;
            background: transparent;
          }
        }
      }
      .list {
        padding: 10px 0 50px 0;
        display: flex;
        align-items: center;
        // column-gap:20px;
        // row-gap:20px;
        flex-wrap: wrap;
        box-sizing: border-box;
        gap: 20px;
        .item {
          display: flex;
          flex-wrap: nowrap;
          // width: 750px;
          // flex:0 1 48%;
          flex: 0 0 calc(50% - 10px);
          max-width: 48%;
          height: 270px;
          // margin:0 20px 20px 0;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #ebedf2;
          cursor: pointer;
          .left {
            width: 240px;
            // height: 240px;
            height: 100%;
            flex-shrink: 0;
            .image {
              border: 1px solid #ebedf2;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10px 0 0 10px;
            }
          }
          .right {
            // padding: 0 20px;
            // width: 480px;
            flex: 1;
            max-width: calc(100% - 240px);
            .right-box {
              padding: 0 20px;

              .name-wrap {
                height: 53px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #ebedf2;
                .name {
                  font-size: 18px;
                  color: #333333;
                  font-weight: bold;
                  white-space:nowrap;
                  text-overflow:ellipsis;
                  overflow:hidden;
                }
                .status {
                  width: 70px;
                  height: 25px;
                  line-height: 25px;
                  border-radius: 5px 0px 5px 0px;
                  text-align: center;
                  white-space:nowrap;
                  text-overflow:ellipsis;
                  overflow:hidden;
                  font-family: "Microsoft YaHei";
                  &.draft {
                    color: #30c6d0;
                    border: 1px solid #30c6d0;
                  }
                  &.bargain {
                    color: #ff9000;
                    border: 1px solid #ff9000;
                  }
                  &.confirm_design {
                    color: #e72c28;
                    border: 1px solid #e72c28;
                  }
                }
              }

              .style_no,
              .category,
              .desc,
              .step {
                margin: 6px 0;
                color: #707070;
                font-size: 14px;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow:hidden;  
              }
              .desc {
                height: 40px;
                overflow-y: hidden;
              }

              span {
                color: #4d4d4d;
                font-size: 14px;
              }

              .time {
                margin: 5px 0;
                font-size: 12px;
                color: #808080;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }

              .btn-group {
                margin-top: 23px;
                display: flex;
                justify-content: flex-end;
                .btn {
                  // width: 100px;
                  padding: 0 10px;
                  height: 35px;
                  line-height: 35px;
                  text-align: center;
                  border-radius: 5px;
                  font-size: 14px;
                  margin: 0 5px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  &.btn-del {
                    border: 1px solid #d0d2d6;
                    color: #68696a;
                  }
                  &.btn-design {
                    background: #fa3d5a;
                    color: white;
                  }
                }
              }
            }
          }

          &:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
